import { BinaryDecisionDiagram } from "@smithy/core/endpoints";
const aw = "ref", ax = "argv", ay = "backend", az = "authSchemes", aA = "disableDoubleEncoding", aB = "signingName", aC = "signingRegion", aD = "signingRegionSet";
const a = -1, b = true, c = false, d = "isSet", e = "booleanEquals", f = "stringEquals", g = "coalesce", h = "substring", i = "", j = "aws.partition", k = "partitionResult", l = "accessPointSuffix", m = "regionPrefix", n = (n) => "outpostId_ssa_" + n + i, o = "hardwareType", p = "ite", q = "isValidHostLabel", s = "sigv4", t = "aws.isVirtualHostableS3Bucket", u = "url", v = "getAttr", w = "bucketArn", x = "--", y = "arnType", z = "accesspoint", A = (n) => "accessPointName_ssa_" + n + i, B = "s3-object-lambda", C = "s3-outposts", D = "bucketPartition", E = "us-east-1", F = "outpostType", G = "name", H = "s3", I = "{url#scheme}://{Bucket}.{url#authority}{url#path}", J = "{url#scheme}://{url#authority}{url#path}", K = "{url#scheme}://{url#authority}{url#normalizedPath}{Bucket}", L = "https://{Bucket}.s3-accelerate.{partitionResult#dnsSuffix}", M = "https://{Bucket}.s3.{partitionResult#dnsSuffix}", N = (n) => "{url#scheme}://{accessPointName_ssa_" + n + "}-{bucketArn#accountId}.{url#authority}{url#path}", O = (n) => "Invalid ARN: The access point name may only contain a-z, A-Z, 0-9 and `-`. Found: `{accessPointName_ssa_" + n + "}`", P = "sigv4a", Q = "{url#scheme}://{url#authority}{url#normalizedPath}{uri_encoded_bucket}", R = "https://s3.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", S = "https://s3.{partitionResult#dnsSuffix}", T = { [aw]: "UseFIPS" }, U = { [aw]: "UseDualStack" }, V = { [aw]: "Bucket" }, W = { "fn": v, [ax]: [{ [aw]: k }, G] }, X = { [aw]: u }, Y = { [aw]: "Region" }, Z = { [aw]: w }, aa = { [aw]: y }, ab = { [aw]: "accessPointName_ssa_1" }, ac = { "fn": v, [ax]: [Z, "region"] }, ad = { [aw]: o }, ae = { "fn": v, [ax]: [Z, "service"] }, af = { "fn": v, [ax]: [Z, "accountId"] }, ag = { [ay]: "S3Express", [az]: [{ [aA]: true, [G]: "{_s3e_auth}", [aB]: "s3express", [aC]: "{Region}" }] }, ah = { [ay]: "S3Express", [az]: [{ [aA]: true, [G]: s, [aB]: "s3express", [aC]: "{Region}" }] }, ai = { [az]: [{ [aA]: true, [G]: P, [aB]: C, [aD]: ["*"] }, { [aA]: true, [G]: s, [aB]: C, [aC]: "{Region}" }] }, aj = { [az]: [{ [aA]: true, [G]: s, [aB]: H, [aC]: E }] }, ak = { [az]: [{ [aA]: true, [G]: s, [aB]: H, [aC]: "{Region}" }] }, al = { [az]: [{ [aA]: true, [G]: s, [aB]: B, [aC]: "{bucketArn#region}" }] }, am = { [az]: [{ [aA]: true, [G]: s, [aB]: H, [aC]: "{bucketArn#region}" }] }, an = { [az]: [{ [aA]: true, [G]: P, [aB]: C, [aD]: ["*"] }, { [aA]: true, [G]: s, [aB]: C, [aC]: "{bucketArn#region}" }] }, ao = { [az]: [{ [aA]: true, [G]: s, [aB]: B, [aC]: "{Region}" }] }, ap = [Y], aq = [{ [aw]: "Endpoint" }], as = [V], at = [V, 0, 7, true], au = [Z, "resourceId[1]"], av = ["*"];
const _data = {
    conditions: [
        [d, ap],
        [e, [{ [aw]: "Accelerate" }, b]],
        [e, [T, b]],
        [e, [U, b]],
        [d, aq],
        [d, as],
        [f, [{ fn: g, [ax]: [{ fn: h, [ax]: [V, 0, 6, b] }, i] }, "--x-s3"]],
        [f, [{ fn: g, [ax]: [{ fn: h, [ax]: at }, i] }, "--xa-s3"]],
        [j, ap, k],
        [h, at, l],
        [f, [{ [aw]: l }, "--op-s3"]],
        [h, [V, 8, 12, b], m],
        [h, [V, 32, 49, b], n(2)],
        [h, [V, 49, 50, b], o],
        [e, [{ [aw]: "ForcePathStyle" }, b]],
        [f, [W, "aws-cn"]],
        [p, [U, ".dualstack", i], "_s3e_ds"],
        [q, [{ [aw]: n(2) }, c]],
        [p, [T, "-fips", i], "_s3e_fips"],
        [p, [{ fn: g, [ax]: [{ [aw]: "DisableS3ExpressSessionAuth" }, c] }, s, "sigv4-s3express"], "_s3e_auth"],
        [t, [V, c]],
        ["parseURL", aq, u],
        [e, [{ fn: g, [ax]: [{ [aw]: "UseS3ExpressControlEndpoint" }, c] }, b]],
        [t, [V, b]],
        [f, [{ fn: v, [ax]: [X, "scheme"] }, "http"]],
        [q, [Y, c]],
        ["aws.parseArn", as, w],
        [v, [{ fn: "split", [ax]: [V, x, 0] }, "[-2]"], "s3expressAvailabilityZoneId"],
        [f, [{ fn: g, [ax]: [{ fn: h, [ax]: [V, 0, 4, c] }, i] }, "arn:"]],
        [f, [{ fn: g, [ax]: [{ fn: h, [ax]: [V, 16, 18, b] }, i] }, x]],
        [e, [{ fn: v, [ax]: [X, "isIp"] }, b]],
        [f, [{ fn: g, [ax]: [{ fn: h, [ax]: [V, 21, 23, b] }, i] }, x]],
        [f, [{ fn: g, [ax]: [{ fn: h, [ax]: [V, 27, 29, b] }, i] }, x]],
        [f, [{ [aw]: m }, "beta"]],
        ["uriEncode", as, "uri_encoded_bucket"],
        [q, [Y, b]],
        [e, [{ fn: g, [ax]: [{ [aw]: "UseObjectLambdaEndpoint" }, c] }, b]],
        [v, [Z, "resourceId[0]"], y],
        [f, [aa, i]],
        [f, [aa, z]],
        [v, au, A(1)],
        [f, [ab, i]],
        [f, [ac, i]],
        [f, [{ fn: g, [ax]: [{ fn: h, [ax]: [V, 14, 16, b] }, i] }, x]],
        [f, [ad, "e"]],
        [f, [ad, "o"]],
        [f, [Y, "aws-global"]],
        [f, [{ fn: g, [ax]: [{ fn: h, [ax]: [V, 19, 21, b] }, i] }, x]],
        [f, [ae, B]],
        [e, [{ fn: g, [ax]: [{ [aw]: "DisableAccessPoints" }, c] }, b]],
        [f, [ae, C]],
        [j, [ac], D],
        [q, [ab, b]],
        [f, [{ fn: g, [ax]: [{ fn: h, [ax]: [V, 26, 28, b] }, i] }, x]],
        [f, [{ fn: g, [ax]: [{ fn: h, [ax]: [V, 15, 17, b] }, i] }, x]],
        [v, [Z, "resourceId[4]"]],
        [f, [{ fn: g, [ax]: [{ fn: h, [ax]: [V, 20, 22, b] }, i] }, x]],
        [e, [{ [aw]: "UseGlobalEndpoint" }, b]],
        [f, [Y, E]],
        [v, au, n(1)],
        [e, [{ fn: g, [ax]: [{ [aw]: "UseArnRegion" }, b] }, b]],
        [q, [{ [aw]: n(1) }, c]],
        [v, [Z, "resourceId[2]"], F],
        [f, [Y, ac]],
        [f, [{ fn: v, [ax]: [{ [aw]: D }, G] }, W]],
        [e, [{ [aw]: "DisableMultiRegionAccessPoints" }, b]],
        [q, [ac, b]],
        [f, [{ fn: v, [ax]: [Z, "partition"] }, W]],
        [f, [af, i]],
        [f, [ae, H]],
        [q, [af, c]],
        [v, [Z, "resourceId[3]"], A(2)],
        [q, [ab, c]],
        [f, [{ [aw]: F }, z]],
        [q, [{ [aw]: A(2) }, c]]
    ],
    results: [
        [a],
        [a, "Accelerate cannot be used with FIPS"],
        [a, "Cannot set dual-stack in combination with a custom endpoint."],
        [a, "A custom endpoint cannot be combined with FIPS"],
        [a, "A custom endpoint cannot be combined with S3 Accelerate"],
        [a, "Partition does not support FIPS"],
        [a, "S3Express does not support S3 Accelerate."],
        ["{url#scheme}://{url#authority}/{uri_encoded_bucket}{url#path}", ag],
        [I, ag],
        [a, "S3Express bucket name is not a valid virtual hostable name."],
        ["https://s3express-control{_s3e_fips}{_s3e_ds}.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", ah],
        ["https://{Bucket}.s3express{_s3e_fips}-{s3expressAvailabilityZoneId}{_s3e_ds}.{Region}.{partitionResult#dnsSuffix}", ag],
        [a, "Unrecognized S3Express bucket name format."],
        [J, ag],
        ["https://s3express-control{_s3e_fips}{_s3e_ds}.{Region}.{partitionResult#dnsSuffix}", ah],
        [a, "Expected a endpoint to be specified but no endpoint was found"],
        ["https://{Bucket}.ec2.{url#authority}", ai],
        ["https://{Bucket}.ec2.s3-outposts.{Region}.{partitionResult#dnsSuffix}", ai],
        ["https://{Bucket}.op-{outpostId_ssa_2}.{url#authority}", ai],
        ["https://{Bucket}.op-{outpostId_ssa_2}.s3-outposts.{Region}.{partitionResult#dnsSuffix}", ai],
        [a, "Unrecognized hardware type: \"Expected hardware type o or e but got {hardwareType}\""],
        [a, "Invalid Outposts Bucket alias - it must be a valid bucket name."],
        [a, "Invalid ARN: The outpost Id must only contain a-z, A-Z, 0-9 and `-`."],
        [a, "Custom endpoint `{Endpoint}` was not a valid URI"],
        [a, "S3 Accelerate cannot be used in this region"],
        ["https://{Bucket}.s3-fips.dualstack.us-east-1.{partitionResult#dnsSuffix}", aj],
        ["https://{Bucket}.s3-fips.dualstack.{Region}.{partitionResult#dnsSuffix}", ak],
        ["https://{Bucket}.s3-fips.us-east-1.{partitionResult#dnsSuffix}", aj],
        ["https://{Bucket}.s3-fips.{Region}.{partitionResult#dnsSuffix}", ak],
        ["https://{Bucket}.s3-accelerate.dualstack.us-east-1.{partitionResult#dnsSuffix}", aj],
        ["https://{Bucket}.s3-accelerate.dualstack.{partitionResult#dnsSuffix}", ak],
        ["https://{Bucket}.s3.dualstack.us-east-1.{partitionResult#dnsSuffix}", aj],
        ["https://{Bucket}.s3.dualstack.{Region}.{partitionResult#dnsSuffix}", ak],
        [K, aj],
        [I, aj],
        [K, ak],
        [I, ak],
        [L, aj],
        [L, ak],
        [M, aj],
        [M, ak],
        ["https://{Bucket}.s3.{Region}.{partitionResult#dnsSuffix}", ak],
        [a, "Invalid region: region was not a valid DNS name."],
        [a, "S3 Object Lambda does not support Dual-stack"],
        [a, "S3 Object Lambda does not support S3 Accelerate"],
        [a, "Access points are not supported for this operation"],
        [a, "Invalid configuration: region from ARN `{bucketArn#region}` does not match client region `{Region}` and UseArnRegion is `false`"],
        [a, "Invalid ARN: Missing account id"],
        [N(1), al],
        ["https://{accessPointName_ssa_1}-{bucketArn#accountId}.s3-object-lambda-fips.{bucketArn#region}.{bucketPartition#dnsSuffix}", al],
        ["https://{accessPointName_ssa_1}-{bucketArn#accountId}.s3-object-lambda.{bucketArn#region}.{bucketPartition#dnsSuffix}", al],
        [a, O(1)],
        [a, "Invalid ARN: The account id may only contain a-z, A-Z, 0-9 and `-`. Found: `{bucketArn#accountId}`"],
        [a, "Invalid region in ARN: `{bucketArn#region}` (invalid DNS name)"],
        [a, "Client was configured for partition `{partitionResult#name}` but ARN (`{Bucket}`) has `{bucketPartition#name}`"],
        [a, "Invalid ARN: The ARN may only contain a single resource component after `accesspoint`."],
        [a, "Invalid ARN: bucket ARN is missing a region"],
        [a, "Invalid ARN: Expected a resource of the format `accesspoint:<accesspoint name>` but no name was provided"],
        [a, "Invalid ARN: Object Lambda ARNs only support `accesspoint` arn types, but found: `{arnType}`"],
        [a, "Access Points do not support S3 Accelerate"],
        ["https://{accessPointName_ssa_1}-{bucketArn#accountId}.s3-accesspoint-fips.dualstack.{bucketArn#region}.{bucketPartition#dnsSuffix}", am],
        ["https://{accessPointName_ssa_1}-{bucketArn#accountId}.s3-accesspoint-fips.{bucketArn#region}.{bucketPartition#dnsSuffix}", am],
        ["https://{accessPointName_ssa_1}-{bucketArn#accountId}.s3-accesspoint.dualstack.{bucketArn#region}.{bucketPartition#dnsSuffix}", am],
        [N(1), am],
        ["https://{accessPointName_ssa_1}-{bucketArn#accountId}.s3-accesspoint.{bucketArn#region}.{bucketPartition#dnsSuffix}", am],
        [a, "Invalid ARN: The ARN was not for the S3 service, found: {bucketArn#service}"],
        [a, "S3 MRAP does not support dual-stack"],
        [a, "S3 MRAP does not support FIPS"],
        [a, "S3 MRAP does not support S3 Accelerate"],
        [a, "Invalid configuration: Multi-Region Access Point ARNs are disabled."],
        ["https://{accessPointName_ssa_1}.accesspoint.s3-global.{partitionResult#dnsSuffix}", { [az]: [{ [aA]: b, name: P, [aB]: H, [aD]: av }] }],
        [a, "Client was configured for partition `{partitionResult#name}` but bucket referred to partition `{bucketArn#partition}`"],
        [a, "Invalid Access Point Name"],
        [a, "S3 Outposts does not support Dual-stack"],
        [a, "S3 Outposts does not support FIPS"],
        [a, "S3 Outposts does not support S3 Accelerate"],
        [a, "Invalid Arn: Outpost Access Point ARN contains sub resources"],
        ["https://{accessPointName_ssa_2}-{bucketArn#accountId}.{outpostId_ssa_1}.{url#authority}", an],
        ["https://{accessPointName_ssa_2}-{bucketArn#accountId}.{outpostId_ssa_1}.s3-outposts.{bucketArn#region}.{bucketPartition#dnsSuffix}", an],
        [a, O(2)],
        [a, "Expected an outpost type `accesspoint`, found {outpostType}"],
        [a, "Invalid ARN: expected an access point name"],
        [a, "Invalid ARN: Expected a 4-component resource"],
        [a, "Invalid ARN: The outpost Id may only contain a-z, A-Z, 0-9 and `-`. Found: `{outpostId_ssa_1}`"],
        [a, "Invalid ARN: The Outpost Id was not set"],
        [a, "Invalid ARN: Unrecognized format: {Bucket} (type: {arnType})"],
        [a, "Invalid ARN: No ARN type specified"],
        [a, "Invalid ARN: `{Bucket}` was not a valid ARN"],
        [a, "Path-style addressing cannot be used with ARN buckets"],
        ["https://s3-fips.dualstack.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", aj],
        ["https://s3-fips.dualstack.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", ak],
        ["https://s3-fips.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", aj],
        ["https://s3-fips.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", ak],
        ["https://s3.dualstack.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", aj],
        ["https://s3.dualstack.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", ak],
        [Q, aj],
        [Q, ak],
        [R, aj],
        [R, ak],
        ["https://s3.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", ak],
        [a, "Path-style addressing cannot be used with S3 Accelerate"],
        [J, ao],
        ["https://s3-object-lambda-fips.{Region}.{partitionResult#dnsSuffix}", ao],
        ["https://s3-object-lambda.{Region}.{partitionResult#dnsSuffix}", ao],
        ["https://s3-fips.dualstack.us-east-1.{partitionResult#dnsSuffix}", aj],
        ["https://s3-fips.dualstack.{Region}.{partitionResult#dnsSuffix}", ak],
        ["https://s3-fips.us-east-1.{partitionResult#dnsSuffix}", aj],
        ["https://s3-fips.{Region}.{partitionResult#dnsSuffix}", ak],
        ["https://s3.dualstack.us-east-1.{partitionResult#dnsSuffix}", aj],
        ["https://s3.dualstack.{Region}.{partitionResult#dnsSuffix}", ak],
        [J, aj],
        [J, ak],
        [S, aj],
        [S, ak],
        ["https://s3.{Region}.{partitionResult#dnsSuffix}", ak],
        [a, "A region must be set when sending requests to S3."]
    ]
};
const root = 2;
const r = 100_000_000;
const nodes = new Int32Array([
    -1, 1, -1,
    0, 3, r + 115,
    1, 424, 4,
    2, 272, 5,
    3, 233, 6,
    4, 85, 7,
    5, 15, 8,
    8, 9, r + 115,
    16, 10, 13,
    18, 11, 13,
    19, 12, 13,
    22, r + 14, 13,
    35, 14, r + 42,
    36, r + 103, 435,
    6, 271, 16,
    7, 270, 17,
    8, 19, 18,
    14, 501, 106,
    9, 20, 24,
    10, 21, 24,
    11, 22, 24,
    12, 23, 24,
    13, 547, 24,
    14, 77, 25,
    20, 73, 26,
    26, 27, 78,
    37, 28, r + 86,
    38, r + 86, 29,
    39, 47, 30,
    48, r + 58, 31,
    50, 32, r + 85,
    51, 33, 136,
    55, r + 76, 34,
    59, 35, r + 84,
    60, 39, 36,
    61, 37, r + 83,
    62, 38, 146,
    63, 41, r + 46,
    61, 40, r + 83,
    62, 41, 150,
    64, 42, r + 54,
    66, 43, r + 53,
    70, 44, r + 52,
    71, 45, r + 81,
    73, 46, r + 80,
    74, r + 78, r + 79,
    40, 48, r + 57,
    41, r + 57, 49,
    42, 185, 50,
    48, 62, 51,
    49, r + 45, 52,
    51, 53, 526,
    60, 56, 54,
    62, r + 55, 55,
    63, 57, r + 46,
    62, r + 55, 57,
    64, 58, r + 54,
    66, 59, r + 53,
    69, 60, r + 65,
    70, 61, r + 52,
    72, r + 64, r + 51,
    49, r + 45, 63,
    51, 64, 526,
    60, 67, 65,
    62, r + 55, 66,
    63, 68, r + 46,
    62, r + 55, 68,
    64, 69, r + 54,
    66, 70, r + 53,
    68, r + 47, 71,
    70, 72, r + 52,
    72, r + 50, r + 51,
    25, 74, r + 42,
    46, r + 39, 75,
    57, 76, r + 41,
    58, r + 40, r + 41,
    26, r + 88, 78,
    28, r + 87, 79,
    34, 82, 80,
    35, 81, 545,
    36, r + 103, r + 115,
    46, r + 97, 83,
    57, 84, r + 99,
    58, r + 98, r + 99,
    5, 101, 86,
    8, 87, r + 115,
    16, 88, 89,
    18, 91, 89,
    19, 90, 92,
    21, 97, 95,
    19, 93, 92,
    21, 98, 95,
    21, 97, 94,
    22, r + 14, 95,
    35, 96, r + 42,
    36, r + 103, r + 42,
    22, r + 13, 98,
    35, 99, r + 42,
    36, r + 101, 100,
    46, r + 110, r + 111,
    6, 214, 102,
    7, 208, 103,
    8, 119, 104,
    14, 118, 105,
    21, 106, r + 23,
    26, 107, 502,
    37, 108, r + 86,
    38, r + 86, 109,
    39, 112, 110,
    48, r + 58, 111,
    50, 136, r + 85,
    40, 113, r + 57,
    41, r + 57, 114,
    42, 115, 500,
    48, r + 56, 116,
    52, 117, r + 72,
    65, r + 69, r + 72,
    21, 501, r + 23,
    9, 120, 124,
    10, 121, 124,
    11, 122, 124,
    12, 123, 124,
    13, 202, 124,
    14, 195, 125,
    20, 190, 126,
    21, 127, r + 23,
    23, 128, 129,
    24, 189, 129,
    26, 130, 197,
    37, 131, r + 86,
    38, r + 86, 132,
    39, 159, 133,
    48, r + 58, 134,
    50, 135, r + 85,
    51, 141, 136,
    55, r + 76, 137,
    59, 138, r + 84,
    60, r + 83, 139,
    61, 140, r + 83,
    63, r + 83, r + 46,
    55, r + 76, 142,
    59, 143, r + 84,
    60, 148, 144,
    61, 145, r + 83,
    62, 147, 146,
    63, 150, r + 46,
    63, 153, r + 46,
    61, 149, r + 83,
    62, 153, 150,
    64, 151, r + 54,
    66, 152, r + 53,
    70, r + 82, r + 52,
    64, 154, r + 54,
    66, 155, r + 53,
    70, 156, r + 52,
    71, 157, r + 81,
    73, 158, r + 80,
    74, r + 77, r + 79,
    40, 160, r + 57,
    41, r + 57, 161,
    42, 185, 162,
    48, 174, 163,
    49, r + 45, 164,
    51, 165, 526,
    60, 168, 166,
    62, r + 55, 167,
    63, 169, r + 46,
    62, r + 55, 169,
    64, 170, r + 54,
    66, 171, r + 53,
    69, 172, r + 65,
    70, 173, r + 52,
    72, r + 63, r + 51,
    49, r + 45, 175,
    51, 176, 526,
    60, 179, 177,
    62, r + 55, 178,
    63, 180, r + 46,
    62, r + 55, 180,
    64, 181, r + 54,
    66, 182, r + 53,
    68, r + 47, 183,
    70, 184, r + 52,
    72, r + 48, r + 51,
    48, r + 56, 186,
    52, 187, r + 72,
    65, r + 69, 188,
    67, r + 70, r + 71,
    25, r + 36, r + 42,
    21, 191, r + 23,
    25, 192, r + 42,
    30, 194, 193,
    46, r + 34, r + 36,
    46, r + 33, r + 35,
    21, 196, r + 23,
    26, r + 88, 197,
    28, r + 87, 198,
    34, 201, 199,
    35, 200, 545,
    36, r + 101, r + 115,
    46, r + 95, r + 96,
    17, 203, r + 22,
    20, 204, r + 21,
    21, 205, 550,
    33, 206, 550,
    44, r + 16, 207,
    45, r + 18, r + 20,
    8, 209, 215,
    16, 210, 220,
    18, 211, 220,
    19, 212, 224,
    20, 213, 227,
    21, 231, 401,
    8, 218, 215,
    19, 216, r + 9,
    20, 217, 227,
    21, 231, r + 9,
    16, 219, 220,
    18, 223, 220,
    19, 221, 224,
    20, 222, 227,
    21, 231, r + 12,
    19, 226, 224,
    20, 225, r + 9,
    21, r + 9, r + 12,
    20, 230, 227,
    21, 228, r + 9,
    30, 229, r + 9,
    34, r + 7, r + 9,
    21, 231, 415,
    30, 232, r + 8,
    34, r + 7, r + 8,
    4, r + 2, 234,
    5, 235, 480,
    6, 271, 236,
    7, 270, 237,
    8, 238, 491,
    9, 239, 243,
    10, 240, 243,
    11, 241, 243,
    12, 242, 243,
    13, 547, 243,
    14, 266, 244,
    20, 264, 245,
    26, 246, 267,
    37, 247, r + 86,
    38, r + 86, 248,
    39, 249, 518,
    40, 250, r + 57,
    41, r + 57, 251,
    42, 538, 252,
    48, r + 43, 253,
    49, r + 45, 254,
    51, 255, 526,
    60, 258, 256,
    62, r + 55, 257,
    63, 259, r + 46,
    62, r + 55, 259,
    64, 260, r + 54,
    66, 261, r + 53,
    69, 262, r + 65,
    70, 263, r + 52,
    72, r + 62, r + 51,
    25, 265, r + 42,
    46, r + 31, r + 32,
    26, r + 88, 267,
    28, r + 87, 268,
    34, 269, 544,
    46, r + 93, r + 94,
    8, 397, r + 9,
    8, 407, r + 9,
    3, 346, 273,
    4, r + 3, 274,
    5, 284, 275,
    8, 276, r + 115,
    15, r + 5, 277,
    16, 278, 281,
    18, 279, 281,
    19, 280, 281,
    22, r + 14, 281,
    35, 282, r + 42,
    36, r + 102, 283,
    46, r + 106, r + 107,
    6, 405, 285,
    7, 395, 286,
    8, 295, 287,
    14, 501, 288,
    26, 289, 502,
    37, 290, r + 86,
    38, r + 86, 291,
    39, 292, 307,
    40, 293, r + 57,
    41, r + 57, 294,
    42, 335, 500,
    9, 296, 300,
    10, 297, 300,
    11, 298, 300,
    12, 299, 300,
    13, 394, 300,
    14, 339, 301,
    15, r + 5, 302,
    20, 337, 303,
    26, 304, 341,
    37, 305, r + 86,
    38, r + 86, 306,
    39, 309, 307,
    48, r + 58, 308,
    50, r + 74, r + 85,
    40, 310, r + 57,
    41, r + 57, 311,
    42, 335, 312,
    48, 324, 313,
    49, r + 45, 314,
    51, 315, 526,
    60, 318, 316,
    62, r + 55, 317,
    63, 319, r + 46,
    62, r + 55, 319,
    64, 320, r + 54,
    66, 321, r + 53,
    69, 322, r + 65,
    70, 323, r + 52,
    72, r + 61, r + 51,
    49, r + 45, 325,
    51, 326, 526,
    60, 329, 327,
    62, r + 55, 328,
    63, 330, r + 46,
    62, r + 55, 330,
    64, 331, r + 54,
    66, 332, r + 53,
    68, r + 47, 333,
    70, 334, r + 52,
    72, r + 49, r + 51,
    48, r + 56, 336,
    52, r + 67, r + 72,
    25, 338, r + 42,
    46, r + 27, r + 28,
    15, r + 5, 340,
    26, r + 88, 341,
    28, r + 87, 342,
    34, 345, 343,
    35, 344, 545,
    36, r + 102, r + 115,
    46, r + 91, r + 92,
    4, r + 2, 347,
    5, 357, 348,
    8, 349, r + 115,
    15, r + 5, 350,
    16, 351, 354,
    18, 352, 354,
    19, 353, 354,
    22, r + 14, 354,
    35, 355, r + 42,
    36, r + 43, 356,
    46, r + 104, r + 105,
    6, 405, 358,
    7, 395, 359,
    8, 360, 491,
    9, 361, 365,
    10, 362, 365,
    11, 363, 365,
    12, 364, 365,
    13, 394, 365,
    14, 389, 366,
    15, r + 5, 367,
    20, 387, 368,
    26, 369, 391,
    37, 370, r + 86,
    38, r + 86, 371,
    39, 372, 518,
    40, 373, r + 57,
    41, r + 57, 374,
    42, 538, 375,
    48, r + 43, 376,
    49, r + 45, 377,
    51, 378, 526,
    60, 381, 379,
    62, r + 55, 380,
    63, 382, r + 46,
    62, r + 55, 382,
    64, 383, r + 54,
    66, 384, r + 53,
    69, 385, r + 65,
    70, 386, r + 52,
    72, r + 60, r + 51,
    25, 388, r + 42,
    46, r + 25, r + 26,
    15, r + 5, 390,
    26, r + 88, 391,
    28, r + 87, 392,
    34, 393, 544,
    46, r + 89, r + 90,
    15, r + 5, 547,
    8, 396, r + 9,
    15, r + 5, 397,
    16, 398, 410,
    18, 399, 410,
    19, 400, 410,
    20, 401, r + 9,
    27, 402, r + 12,
    29, r + 11, 403,
    31, r + 11, 404,
    32, r + 11, 422,
    8, 406, r + 9,
    15, r + 5, 407,
    16, 408, 410,
    18, 409, 410,
    19, 411, 410,
    20, r + 12, r + 9,
    20, 414, 412,
    22, 413, r + 9,
    34, r + 10, r + 9,
    22, 416, 415,
    27, 419, r + 12,
    27, 418, 417,
    34, r + 10, r + 12,
    34, r + 10, 419,
    43, r + 11, 420,
    47, r + 11, 421,
    53, r + 11, 422,
    54, r + 11, 423,
    56, r + 11, r + 12,
    2, r + 1, 425,
    3, 478, 426,
    4, r + 4, 427,
    5, 438, 428,
    8, 429, r + 115,
    16, 430, 433,
    18, 431, 433,
    19, 432, 433,
    22, r + 14, 433,
    35, 434, r + 42,
    36, r + 44, 435,
    46, r + 112, 436,
    57, 437, r + 114,
    58, r + 113, r + 114,
    6, r + 6, 439,
    7, r + 6, 440,
    8, 450, 441,
    14, 501, 442,
    26, 443, 502,
    37, 444, r + 86,
    38, r + 86, 445,
    39, 446, 465,
    40, 447, r + 57,
    41, r + 57, 448,
    42, 471, 449,
    48, r + 44, 500,
    9, 451, 455,
    10, 452, 455,
    11, 453, 455,
    12, 454, 455,
    13, 547, 455,
    14, 473, 456,
    15, 460, 457,
    20, 458, 461,
    25, 459, r + 42,
    46, r + 37, r + 38,
    20, 540, 461,
    26, 462, 474,
    37, 463, r + 86,
    38, r + 86, 464,
    39, 467, 465,
    48, r + 58, 466,
    50, r + 75, r + 85,
    40, 468, r + 57,
    41, r + 57, 469,
    42, 471, 470,
    48, r + 44, 524,
    48, r + 44, 472,
    52, r + 68, r + 72,
    26, r + 88, 474,
    28, r + 87, 475,
    34, r + 100, 476,
    35, 477, 545,
    36, r + 44, r + 115,
    4, r + 2, 479,
    5, 488, 480,
    8, 481, r + 115,
    16, 482, 485,
    18, 483, 485,
    19, 484, 485,
    22, r + 14, 485,
    35, 486, r + 42,
    36, r + 43, 487,
    46, r + 108, r + 109,
    6, r + 6, 489,
    7, r + 6, 490,
    8, 503, 491,
    14, 501, 492,
    26, 493, 502,
    37, 494, r + 86,
    38, r + 86, 495,
    39, 496, 518,
    40, 497, r + 57,
    41, r + 57, 498,
    42, 538, 499,
    48, r + 43, 500,
    49, r + 45, 526,
    26, r + 88, 502,
    28, r + 87, r + 115,
    9, 504, 508,
    10, 505, 508,
    11, 506, 508,
    12, 507, 508,
    13, 547, 508,
    14, 541, 509,
    15, 513, 510,
    20, 511, 514,
    25, 512, r + 42,
    46, r + 29, r + 30,
    20, 540, 514,
    26, 515, 542,
    37, 516, r + 86,
    38, r + 86, 517,
    39, 520, 518,
    48, r + 58, 519,
    50, r + 73, r + 85,
    40, 521, r + 57,
    41, r + 57, 522,
    42, 538, 523,
    48, r + 43, 524,
    49, r + 45, 525,
    51, 529, 526,
    60, r + 55, 527,
    62, r + 55, 528,
    63, r + 55, r + 46,
    60, 532, 530,
    62, r + 55, 531,
    63, 533, r + 46,
    62, r + 55, 533,
    64, 534, r + 54,
    66, 535, r + 53,
    69, 536, r + 65,
    70, 537, r + 52,
    72, r + 59, r + 51,
    48, r + 43, 539,
    52, r + 66, r + 72,
    25, r + 24, r + 42,
    26, r + 88, 542,
    28, r + 87, 543,
    34, r + 100, 544,
    35, 546, 545,
    36, r + 42, r + 115,
    36, r + 43, r + 115,
    17, 548, r + 22,
    20, 549, r + 21,
    33, 552, 550,
    44, r + 17, 551,
    45, r + 19, r + 20,
    44, r + 15, 553,
    45, r + 15, r + 20,
]);
export const bdd = BinaryDecisionDiagram.from(nodes, root, _data.conditions, _data.results);
